export default __webpack_public_path__ + "static/media/1.a3b887b7.svg";